import { TextInputField } from 'components/Form/TextInputField'
import { FeaturedMediaImage } from '../FeaturedMediaImage/FeaturedMediaImage'
import { FeaturedMediaSelectModal } from '../FeaturedMediaSelectModal/FeaturedMediaSelectModal'
import { BlogMetadataImagesState, BlogMetadataImagesHandlers } from '../../../hooks/useBlogMetadataImages'
import Styles from '../../../BlogMetadata.module.scss'

interface BlogMetadataImageSectionProps {
  imagesState: BlogMetadataImagesState
  handlers: BlogMetadataImagesHandlers
}

export const BlogMetadataImageSection: React.FC<BlogMetadataImageSectionProps> = ({ imagesState, handlers }) => {
  const { featuredImageUrl, featuredImageAltText, imageLoading, imageError, featuredImages } = imagesState
  const {
    handleFeaturedImageAltChange,
    handleDirectUpload,
    handleOpenFeaturedMediaModal,
    setImageLoading,
    setImageError,
  } = handlers

  const handleOpenModal = (): void => {
    handleOpenFeaturedMediaModal(FeaturedMediaSelectModal)
  }

  return (
    <>
      <div className={Styles.featuredImageLabel}>
        <FeaturedMediaImage
          featuredImageUrl={featuredImageUrl}
          featuredImageAltText={featuredImageAltText}
          imageLoading={imageLoading}
          imageError={imageError}
          setImageLoading={setImageLoading}
          setImageError={setImageError}
          handleOpenFeaturedMediaModal={handleOpenModal}
          handleDirectUpload={handleDirectUpload}
          hasExistingImages={featuredImages.length > 0}
        />
      </div>
      <TextInputField
        wrapperClassName={Styles.inputField}
        label="Featured Image Alt Text"
        value={featuredImageAltText}
        onChange={handleFeaturedImageAltChange}
        size="lg"
        labelClassName={Styles.textFieldLabel}
        placeholder="Enter a description for your featured image"
      />
    </>
  )
}
